import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    thumbnail: {
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      backgroundSize: 'cover !important',
    },
    loading: {
      height: '100%',
    },
    photoCardAdd: {
      width: '100%',
      height: '100%',
      borderRadius: '4px',
    },
    icon: {
      height: '100px',
      width: '100px',
      marginBottom: '10px',
    },
    centerContent: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
    },
    progressBar: {
      width: '100%',
      position: 'absolute',
      bottom: 0,
      '& > div': {
        backgroundColor: '#C4C4C4',
        height: '5px',
      },
    },
    metadata: {
      width: '100%',
      position: 'absolute',
      bottom: 0,
      backgroundColor: '#383838',
      padding: '8px 12px',
      color: 'rgba(255, 255, 255, 0.87)',
      borderRadius: '0px 0px 4px 4px',
    },
    metadata2: {
      position: 'absolute',
      right: 0,
      margin: 4,
      color: 'rgba(255, 255, 255, 0.87)',
      borderRadius: '0px 0px 4px 4px',
    },
    hideDiv: {
      display: 'none',
    },
    paper: {
      width: '200px',
      backgroundColor: 'transparent',
    },
    viewImage: {
      maxWidth: '100%',
      maxHeight: '80vh',
      justifyContent: 'center',
    },

    viewFullImage: {
      maxWidth: '100%',
      maxHeight: '80vh',
      minHeight: '20vh',
    },
    imageBox: {
      width: '100%',
      height: '100%',
      alignSelf: 'center',
    },
    editDetailsGrid: {
      backgroundColor: '#121212',
      borderRadius: 4,
    },
    editDetails: {
      minWidth: '100%',
    },
    editDetailstext: {
      width: '100%',
      lineHeight: '20px',
      letterSpacing: '0.5px',
      textAlign: 'right',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    loadingGrid: {
      backgroundColor: '#C4C4C4',
      opacity: 0.9,
      height: '100%',
      width: '100%',
    },
    uploadingGrid: {
      alignSelf: 'center',
    },
    progressText: {
      color: 'black',
      textAlignLast: 'center',
    },
    uploadText: {
      color: 'black',
    },
    verticalFeather: {
      height: 40,
      width: 40,
      lineHeight: '50px',
      background: 'black',
      borderRadius: '100px',
      textAlign: 'center',
    },
    fileName: {
      overflowWrap: 'anywhere',
      top: 2,
      left: 24,
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 600,
      letterSpacing: '0.1px',
      margin: '8px 0px',
    },
    fileDescription: {
      overflowWrap: 'anywhere',
      letterSpacing: '0.4px',
      top: 2,
      left: 24,
      fontSize: 12,
      lineHeight: '15px',
      fontWeight: 400,
    },
    readMore: {
      fontSize: 12,
      display: 'inline-block',
    },
    showOnReport: {
      top: 2,
      left: 24,
      fontSize: 12,
      fontWeight: 600,
    },
    fileBox: {
      textAlign: 'justify',
      height: 'fit-content',
    },
    fileDiv: {
      alignSelf: 'center',
      marginBottom: '33%',
    },
    verticalDots: {
      height: 40,
      width: 40,
      lineHeight: '53px',
      background: 'black',
      borderRadius: '100px',
      textAlign: 'center',
    },
    dialogPadding: {
      padding: 5,
    },
    dialogContentPadding: {
      padding: '25px 0px 25px 0px',
      '& .fileName': {
        fontSize: 12,
        fontWeight: 600,
      },
      '& .inputName': {
        width: '100%',
        paddingBottom: '16px',
        color: 'rgba(255, 255, 255, 0.87)',
      },
      '& .textDescription': {
        width: '100%',
        marginBottom: 5,
        color: 'rgba(255, 255, 255, 0.87)',
      },
    },
    deleteText: {
      width: '100%',
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: '0.15px',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    inputDescription: {
      width: '100%',
      marginBottom: 5,
      color: 'rgba(255, 255, 255, 0.87)',
    },
    cursorPointer: {
      cursor: 'pointer',
    },
    closeButtonGrid: {
      padding: 5,
    },
    fileError: {
      background: 'rgba(255, 255, 255, 0.1)',
    },
    newFileTag: {
      right: 0,
      bottom: 0,
      position: 'absolute',
      zIndex: 1,
      borderLeft: '45px solid transparent',
      borderRight: '45px solid transparent',
      borderTop: '45px solid rgba(42, 171, 63, 1)',
      '-webkit-transform': 'rotate(-45deg)',
      marginRight: -29,
      marginBottom: -6,
      textTransform: 'uppercase',
      '& p': {
        position: 'absolute',
        marginTop: '-2.7rem',
        marginLeft: '-1.1rem',
        letterSpacing: 0.5,
      },
    },
  }),
);

export default useStyles;
export { useStyles };
